import {ExtractRouteParams} from 'react-router';
import {generatePath, useParams} from 'react-router-dom';

import {appRoute} from '../../../app-route';
import {Meta} from '../../../component/meta/meta';
import {BreadCrumbs} from '../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../layout/page/page';
import {MainPageContainer} from '../../../layout/page-card/main-page-card';
import {PageCard} from '../../../layout/page-card/page-card';
import {Spinner} from '../../../layout/spinner/spinner';
import {useLocale} from '../../../provider/locale/locale-hook';
import {
    AutoReplyRuleTypeEnum,
    defaultAutoReplyToReviewData,
    useAutoReplyToReviewById,
} from '../../../service/reviews/reviews-response-templates';
import {getEnumValueEnsure} from '../../../util/enum';
import {useUrl} from '../../../util/url-hook/url-hook';
import {AutoReplyForm} from '../auto-reply-form/auto-reply-form';
import {AutoReplyFormSubHeader} from '../auto-reply-form/auto-reply-form-sub-header';

type EditPageQueryType = {
    ruleType?: string;
};

export function AutoReplyEdit(): JSX.Element {
    const {
        autoReplies: reviewsManagementAutoRepliesRoute,
        reviewsManagementAutoReplyEdit: reviewsManagementAutoReplyEditRoute,
    } = appRoute;

    const {autoReplyId} = useParams<ExtractRouteParams<typeof reviewsManagementAutoReplyEditRoute.path, string>>();
    const {getQuery} = useUrl<EditPageQueryType>();
    const ruleType = getEnumValueEnsure<AutoReplyRuleTypeEnum>(
        AutoReplyRuleTypeEnum,
        getQuery('ruleType'),
        AutoReplyRuleTypeEnum.Company
    );
    const {data: autoReplyResult, isFetching: autoReplyIsInProgress} = useAutoReplyToReviewById(
        autoReplyId ?? '',
        ruleType
    );
    const {getLocalizedString} = useLocale();

    return (
        <Page renderContainer={(children) => <MainPageContainer>{children}</MainPageContainer>}>
            <PageCard>
                <Meta title={getLocalizedString('AUTO_REPLIES__HEADER__EDITING_A_RULE')} />

                <BreadCrumbs
                    list={[
                        {
                            path: reviewsManagementAutoRepliesRoute.path,
                            titleLangKey: 'CATEGORY_NAME__AUTO_REPLIES',
                        },
                        {
                            path: generatePath(reviewsManagementAutoReplyEditRoute.path, {autoReplyId}),
                            titleLangKey: 'AUTO_REPLIES__HEADER__EDITING_A_RULE',
                        },
                    ]}
                />

                <AutoReplyFormSubHeader isEdit />
            </PageCard>
            <AutoReplyForm
                autoReplyData={autoReplyResult || defaultAutoReplyToReviewData}
                autoReplyId={autoReplyId}
                mode="edit"
                ruleType={ruleType}
            />

            <Spinner isShow={autoReplyIsInProgress} position="absolute" />
        </Page>
    );
}
